export default function getSumOfCopies(data?: { copies?: number | null }[]) {
    return data?.reduce((acc, curr) => acc + (Number(curr.copies) || 0), 0) ?? 0
}
